import { AxiosError } from 'axios';

import { notifyError } from 'common/errorNotifier';

export interface HandleExceptionOptions {
  /** When true (default), show a generic error toast. Set false when caller shows a custom message. */
  notifyUser?: boolean;
}

export const handleException = (
  error: unknown,
  options: HandleExceptionOptions = {}
): number | null => {
  const { notifyUser = true } = options;
  const status = error instanceof AxiosError ? (error.response?.status ?? null) : null;
  console.error(error);

  if (notifyUser) {
    const message =
      error instanceof AxiosError &&
      error.response?.data &&
      typeof (error.response.data as { message?: string }).message === 'string'
        ? (error.response.data as { message: string }).message
        : 'An error occurred';
    notifyError(message);
  }
  return status;
};
